import { SyntheticEvent } from "react";
import { DefaultTheme } from "styled-components/macro";

export interface IconProps {
    active?: boolean | "";
}
export interface ArrowIconProps {
    marginright?: boolean;
}
export interface AMPMIconProps {
    active?: boolean | "";
    theme: DefaultTheme;
}

export type dateTimepickerType = "date" | "time" | "datetime";

export type handleChangeType = (date: Date, event: SyntheticEvent | undefined) => void;

export const allMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
